export interface DebtorSetting {
  hasDebtorPortalWebAccess: boolean;
}

export interface DebtorAccountContextType {
  isInternal: boolean;
  selectedDebtor: DebtorAccount | null;
  selectedDebtorName: string | null;
  debtors: DebtorAccount[];
  permissions: DebtorPermission[];
  isLoading: boolean;
  isDebtorSwitching: boolean;
  error: string | null;
  selectDebtor: (debtor: DebtorAccount, debtorName?: string) => Promise<void>;
  initialized: boolean;
  debtorSettings: DebtorSetting | null;
}

export interface DebtorAccount {
  debtorId: number;
  permissions: number[];
}

export interface DebtorCredentialResponse {
  isInternal: boolean;
  debtors: DebtorAccount[];
}

export interface DebtorSearchResult {
  id: string;
  name: string;
  status?: string;
  isNoBuy?: boolean;
  isCompromised?: boolean;
  isOBCNoBuy?: boolean;
  mcNumber?: string;
  creditLimit_Value?: number;
  creditLimit_Code?: string;
  address?: {
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    country?: string;
    zip?: string;
  };
}

export interface DebtorSearchResponse {
  results: DebtorSearchResult[];
  currentPage: number;
}

export interface DebtorSearchRequest {
  searchTerm: string;
  size?: number;
  fields?: string[];
  prioritizeRelationship?: boolean;
  includeCreditCheckHistory?: boolean;
  activeCustomersOnly?: boolean;
  existingRelationshipsOnly?: boolean;
  isExactMatch?: boolean;
  searchableFields?: string[];
  docketsToMatch?: string[];
  idsToMatch?: number[];
}

export interface DebtorSearchFilter {
  field: string;
  operator: string;
  value: string;
}

export interface DebtorSearchSort {
  field: string;
  direction: string;
}

export interface DebtorSearchPagination {
  page: number;
  size: number;
}

export enum DebtorPermission {
  DebtorPortalAccess = 7,
}
